const BillingSection = ({
  register,
  watch,
  appendBilling,
  billingFields,
  removeBilling,
  totalCharge,
  errors,
}) => {
  return (
    <section>
        <div className="rounded p-3 uppercase">
            <button
                type="button"
                className="bg-blue-600 hover:bg-blue-700 text-white text-sm px-4 py-2 rounded shadow mb-4"
                onClick={() => appendBilling({ name: "", unit: 0, price_per_unit: 0, total: 0 })}
            >
                + ADD BILLING ROW
            </button>

            {/* Desktop header */}
            <div className="hidden md:grid grid-cols-4 gap-2 font-semibold border-gray-300 py-1 text-sm">
                <div>CHARGE TYPE</div>
                <div>Unit</div>
                <div>PRICE/UNIT</div>
                <div>TOTAL / ACTIONS</div>
            </div>

            {billingFields.map((row, index) => {
                const unit = watch(`charges.${index}.unit`) || 0;
                const pricePerUnit = watch(`charges.${index}.price_per_unit`) || 0;
                const total = unit * pricePerUnit;
                return (
                    <div
                        key={row.id}
                        className="mb-3 border rounded p-3 md:border-0 md:p-0 md:grid md:grid-cols-4 md:gap-2 md:items-center"
                    >
                    {/* Mobile label */}
                    <div className="flex flex-col mb-2 md:mb-0">
                      <label className="text-xs text-gray-500 mb-1 md:hidden">Charge Type</label>
                      <input
                          {...register(`charges.${index}.name`)}
                          type="text"
                          className="border rounded p-2 text-sm w-full"
                          readOnly={row.fixed}
                          placeholder=""
                      />
                    </div>

                    <div className="flex flex-col mb-2 md:mb-0">
                      <label className="text-xs text-gray-500 mb-1 md:hidden">Unit</label>
                      <input
                          {...register(`charges.${index}.unit`, { valueAsNumber: true })}
                          type="number"
                          min={0}
                          className="border rounded p-2 text-sm w-full"
                          onKeyDown={(e) => {
                              if (e.key === '-' || e.key === 'e' || e.key === 'E') e.preventDefault();
                          }}
                          onInput={(e) => {
                              const value = Number(e.currentTarget.value);
                              if (!Number.isNaN(value) && value < 0) e.currentTarget.value = 0;
                          }}
                      />
                    </div>

                    <div className="flex flex-col mb-2 md:mb-0">
                      <label className="text-xs text-gray-500 mb-1 md:hidden">Price / Unit</label>
                      <input
                          {...register(`charges.${index}.price_per_unit`, { valueAsNumber: true })}
                          type="number"
                          min={0}
                          className="border rounded p-2 text-sm w-full"
                          onKeyDown={(e) => {
                              if (e.key === '-' || e.key === 'e' || e.key === 'E') e.preventDefault();
                          }}
                          onInput={(e) => {
                              const value = Number(e.currentTarget.value);
                              if (!Number.isNaN(value) && value < 0) e.currentTarget.value = 0;
                          }}
                      />
                    </div>

                    <div className="flex items-center justify-between md:justify-start gap-2">
                        <span className="text-sm font-medium">= ₹{total}</span>
                        {!row.fixed && (
                        <button
                            type="button"
                            onClick={() => removeBilling(index)}
                            className="inline-flex items-center rounded-md border border-red-200 bg-red-50 px-2.5 py-1 text-xs font-semibold text-red-700 hover:bg-red-100 hover:border-red-300 transition-colors"
                        >
                            DELETE
                        </button>
                        )}
                    </div>
                </div>
            )})}
            <p className="font-bold mt-2">TOTAL: ₹{totalCharge}</p>
        </div>
    </section>
  );
};

export default BillingSection;
